import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faBoxOpen,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { Badge } from "./ui/badge";

export function RecentSalesTable({ recentSales = [] }) {
  if (!recentSales.length) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-gray-400">
        <FontAwesomeIcon icon={faBoxOpen} className="h-8 w-8 mb-2" />
        <p className="text-sm">No recent sales</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {recentSales.map((sale) => {
        const isSoldOut = sale.noOfUnSold === 0;

        return (
          <div
            key={sale.salesId}
            className="flex items-center justify-between rounded-md border border-gray-300 bg-gray-100/50 p-3"
          >
            <div className="flex flex-col gap-0.5 min-w-0 flex-1">
              <span className="text-sm font-medium text-gray-800 truncate">
                {sale.productName}
              </span>

              <span className="flex items-center gap-1 text-xs text-gray-500">
                <FontAwesomeIcon icon={faStore} className="h-3 w-3" />
                {sale.shopName}
              </span>

              <div className="flex items-center gap-2 text-xs text-gray-600 mt-0.5">
                <span className="flex items-center gap-1 text-green-600">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="h-3.5 w-3.5"
                  />
                  {sale.quantitySold} sold
                </span>

                <span>&middot;</span>

                <span
                  className={`flex items-center gap-1 ${
                    isSoldOut ? "text-gray-400" : "text-red-500"
                  }`}
                >
                  <FontAwesomeIcon icon={faBoxOpen} className="h-3.5 w-3.5" />
                  {sale.noOfUnSold} unsold
                </span>
              </div>
            </div>

            <div className="flex flex-col items-end gap-0.5 shrink-0">
              <span className="text-sm font-semibold text-gray-800">
                TZS {Number(sale.totalRevenue).toLocaleString()}
              </span>

              <Badge
                variant="outline"
                className={
                  isSoldOut
                    ? "border-green-500 text-green-600 bg-green-100"
                    : "border-yellow-500 text-yellow-600 bg-yellow-100"
                }
              >
                {isSoldOut ? "Sold Out" : "In Stock"}
              </Badge>
            </div>
          </div>
        );
      })}
    </div>
  );
}